import { getPublicRouteUrl } from '@nackle/service-urls';

export const idURL = getPublicRouteUrl( 'ID_PROVIDER' );
export const cmxURL = getPublicRouteUrl( 'CMX_SERVICE_V2' );
